import { ControlFacet } from '../models/controls/ControlFacet';
import { ISharingCalloutInnerProps } from '../components/sharingCallout/SharingCallout';
import { ISharingInformation } from '../controls/shareActionControl';

export type IInitializeShareFrame = {
  parentElement: HTMLElement;
  sharingInformation: ISharingInformation;
  calloutProps: ISharingCalloutInnerProps;
};
/**
 * Control hook to override the behavior of the web-specific Sharing callout component.
 */
export const sharingCalloutControl: ControlFacet<{
  itemKey: string | undefined;
}, {
  initializeShareFrame: ((authTokenProps: IInitializeShareFrame) => void) | undefined;
}> = new ControlFacet('sharingCallout');
